<template lang="pug">
//-   `.invisible.overflow-y-scroll > .visible` for invisible scrollbar
.uc-edit-bar-wrapper.fixed.top-0.left-0.right-0.w-full.overflow-y-scroll.z-10.dark.font-sans.primary-indigo(
  v-if="available || isAuthoring"
  :class="isAuthoring ? 'h-0 overflow-visible' : '!invisible'"
)
  .visible
    .uc-edit-bar.w-full.backdrop-blur.visible.bg-widget.flex.flex-col.md_flex-row.items-center(v-if="!isAuthoring")
      button.btn-bar.ripple.text-white.min-h-10(
        :class="{ 'btn-bar-active': mode === 'view' }"
        @click="changeMode('view')"
      )
        uc-icon(icon="mdi:eye")
        uc-text(text="Preview")

      button.btn-bar.ripple.text-white.min-h-10(
        :class="{ 'btn-bar-active': mode === 'edit' }"
        @click="onClickEditor"
      )
        uc-icon(icon="mdi:auto-fix")
        uc-text(text="Editor")

      //- save status message
      .flex.flex-col.md_flex-row.items-center.md_ms-auto.min-h-10(v-if="!isReview && !isSalesDemo && mode==='edit' && saveStatus !== 'clean'")
        .flex.items-center.gap-1.pe-4.min-h-10
          uc-icon.text-xl(icon="svg-spinners:180-ring-with-bg" class="text-primary-500" v-if="saveStatus==='saving'")
          uc-icon.text-xl(icon="ph:check-circle-duotone" class="text-indigo-500" v-if="saveStatus==='saved'")
          uc-icon.text-xl(icon="ph:warning-circle-duotone" class="text-red-500" v-if="saveStatus==='error'")
          uc-text.self-center.text-white.text-xs(
            :text="savedMessage"
            :class="{'opacity-50': saveStatus!=='error'}"
          )

        //- manual save button
        //- button.btn-bar.ripple.text-white.btn-bar-active(
        //-   @click="saveChanges()"
        //- )
        //-   //- v-if="saveStatus === 'error'"
        //-   uc-icon(icon="mdi:content-save")
        //-   span.hidden.sm_inline Save
	
        button.ripple.text-white.md_pr-8.md_pl-6.h-full.items-center.gap-2.pl-3.pr-5.text-base.transition.hover_animate-none.min-h-10(
          :class="[displayAudioBtn, animationSpeed, 'hover_bg-primary-500/30']"
          :disabled="saveStatus!=='saved'"
          @click="openResyncLightbox"
          v-if="saveStatus !== 'error'"
        )
          uc-icon.text-2xl.xs_inline(icon="mingcute:music-3-line")
          uc-text(text="Resync Audio")

      uc-lightbox#lightbox-confirm-resync-audio.sm_p-4.primary-indigo(:locked="true")
        .text-left.flex.flex-col.gap-2.max-w-prose.prose-stack.prose
          h2.m-0.mb-4.text-3xl.font-light.inline-flex.items-center.gap-2
            uc-text(text="Resync Course Audio")
          p.m-0
            uc-text(text="Resync your course audio to reflect your latest text changes.")
          p.m-0.font-bold
            uc-text(text="This process takes a few minutes and should be your final step in the editing process.")
          p.m-0.italic
            uc-text(text="Resync now?")
          .flex.justify-end.gap-4.mt-4
            button.btn.btn-secondary.hover_bg-gray-400(@click="closeLightbox")
              uc-text(text="No, I'm not done editing.")
            button.btn.btn-primary(@click="runResyncAudio")
              uc-text(text="Yes, resync my audio!")

      uc-lightbox#lightbox-resync-audio-progress.sm_p-4.primary-indigo(:locked="true")
        .text-center.flex.flex-col.justify-center.gap-2.max-w-prose.prose-stack.prose.px-8(
          class="min-w-[500px]"
        )
          h2.m-0.pt-7.mb-4.text-3xl.font-light.inline-flex.items-center.gap-2.self-center
            uc-text(text="Resync In Progress")
          .error-indicator.text-6xl.text-indigo-700.flex.items-center.justify-center.my-0(
            :class="{'hidden': !isResyncError, 'h-[175]': true}"
          )
            uc-icon(
              icon="mdi:sync-off"
              class="text-[95px]"
            )
          p.m-0.whitespace-pre-line.whitespace-pre-wrap
            uc-text(:text="progressMessage")
            a.ms-1(
              :href="resyncErrorEmailUrl"
              v-if="isResyncError"
            )
              span support@vinciworks.com
          p.m-0.text-sm.text-gray-500(
            v-if="currentLanguage && !isResyncError && isMultiLingualResync"
          )
            uc-text(
              text="Currently resyncing audio for: ${currentLanguage}"
              :values="{ currentLanguage }"
            )
          .canvas-wrapper.relative.w-full.h-full.self-center.flex.flex-col
            canvas#audio-sync-progress-indicator-wrapper.self-center(
              :class="{'hidden': isResyncCompleted || isResyncError}"
            )
            .completion-indicator.text-6xl.text-indigo-700.flex.items-center.justify-center.my-4(
              :class="{'hidden': !isResyncCompleted, 'h-[175]': true}"
            )
              uc-icon(
                icon="carbon:checkmark-outline"
                class="text-[95px]"
              )

          p.m-0.font-bold(v-if="isMultiLingualResync && isConfirmingCancel")
            uc-text(text="Any remaining languages will not be sent for narration.")
          p.m-0.italic(v-if="isConfirmingCancel")
            uc-text(text="Are you sure you want to cancel the resync?")

          iframe.hidden(
            ref="courseAudioIFrame"
            referrerpolicy="origin-when-cross-origin"
            style="width: 800px; height: 600px; border: 0;"
          )
          .flex.justify-center.gap-4.mt-4
            template(v-if="!isConfirmingCancel")
              button.btn.btn-primary(
                @click="handleCancelClick"
                v-if="!isResyncError && !isResyncCompleted"
              )
                uc-text(text="Cancel")
              button.btn.btn-primary(
                @click="closeLightboxAndReload"
                v-if="!isResyncError && isResyncCompleted"
              )
                uc-text(text="Close")
              button.btn.btn-secondary(
                @click="closeLightboxAndReload"
                v-if="isResyncError"
              )
                uc-text(text="Close")
              button.btn.btn-primary(
                @click="retryResyncAudio"
                v-if="isResyncError"
              )
                uc-text(text="Try again")
            template(v-else)
              button.btn.btn-secondary(@click="handleContinueResync")
                uc-text(text="No, continue the resync")
              button.btn.btn-primary(@click="closeLightboxAndReload")
                uc-text(text="Yes, cancel the resync")

      uc-lightbox#lightbox-audio-translations-check.sm_p-4.primary-indigo(:locked="true")
        .text-left.flex.flex-col.gap-2.max-w-prose.prose-stack.prose
          h2.m-0.mb-4.text-3xl.font-light
            uc-text(text="Resync Course Audio")
          p.m-0
            uc-text(text="To resync audio, your machine translations need to be realigned with your recent edits.")
          p.m-0
            uc-text(text="Don't worry - any translations which you have edited manually will not be overwritten.")
          p.m-0.italic
            uc-text(text="Should we update these translations now?")
          .grid.grid-cols-3.gap-2.my-4
            div(v-for="lang in languages").flex.gap-2.bg-gray-200.p-2.items-center.justify-start
              span  
                Icon(icon="mdi:check-circle" v-if="statuses[`lightbox-translate-${lang}`]?.success") 
                Icon(icon="svg-spinners:180-ring-with-bg" v-else-if="statuses[`lightbox-translate-${lang}`]?.pending") 
                Icon(icon="mdi:close-circle" v-else-if="statuses[`lightbox-translate-${lang}`]?.error")
                Icon.opacity-50(icon="mdi:circle" v-else="")

              span {{languageData?.[lang]?.english}} ({{ lang }})

          p.m-0.italic
            span(v-if="statuses['lightbox-rerun-translations']?.pending")
              uc-text(text="Generating translations...")
            span(v-else-if="statuses['lightbox-rerun-translations']?.success")
              uc-text(text="Translations generated successfully.")
            span(v-else-if="statuses['lightbox-rerun-translations']?.error")
              uc-text(text="Translations completed with errors.")
            span(v-else="") &nbsp;
          .flex.justify-end.gap-4.mt-4
            button.btn.btn-secondary(v-if="useContent().translationsInvalidated" @click="closeLightbox")
              uc-text(text="No, I'm not done editing.")
            button.btn.btn-primary(v-if="useContent().translationsInvalidated" @click="handleTranslationsUpdate")
              uc-text(text="Yes, update my translations!")
            button.btn.btn-primary(v-else @click="openResyncLightbox")
              uc-text(text="Continue")

      uc-lightbox#lightbox-audio-translations-success.sm_p-4.primary-indigo(:locked="true")
        .text-center
          p.m-0
            uc-text(text="Your translations have been updated successfully.")
          button.btn.btn-primary.mt-4(@click="proceedToAudioResync")
            uc-text(text="Continue")

      uc-lightbox#lightbox-save-error.primary-sky.sm_p-4(v-if="!isReview && !isSalesDemo" :locked="true")
        .text-center.flex.flex-col.gap-2.max-w-prose
          h2.m-0.mb-2.text-xl.text-indigo-700.font-semibold.inline-flex.items-center.gap-2.justify-center
            uc-icon.text-3xl.-ms-2(icon="mdi:alert-circle")
            uc-text(text="Oops! Something went wrong trying to save your edit.")
          
          p.m-0
            uc-text(text="Please do not make any further edits. <b>Close the course</b> and relaunch it to try to reestablish the connection.")
        
        template(v-slot:buttons="{ close }")
          .primary-indigo.flex.gap-4.items-center.justify-center
            uc-button.btn(text="Create Support ticket?" @click="reportSaveError" :disabled="submitStatus==='pending' || submitStatus==='success'")
            uc-button.btn.btn-primary(text="Close course" @click="closeCourse")

          .auto-alpha-0.mt-4.-mb-6.text-center.max-w-prose(:class="{'auto-alpha-1': submitStatus !== 'idle'}") 
            p.italic(v-if="submitStatus === 'error'")
              uc-text.text-gray-700(
                text="There was an error sending the ticket request - maybe there's a connection problem? Please try again or contact"
              )
              a.font-semibold.underline.text-indigo-500.ms-1(
                @click="sendErrorReportEmail"
                :href="saveErrorEmailUrl"
              )
                span customisations@vinciworks.com
            span.font-semibold.text-indigo-500.inline-flex.items-center.gap-2(v-else-if="submitStatus === 'pending'")
              uc-text(text="One moment...")
            span.font-semibold.text-indigo-500.inline-flex.items-center.gap-2(v-else-if="submitStatus === 'success'")
              uc-icon(icon="theme:check-circle")
              uc-text(text="A support ticket has been opened and our team will be in touch shortly!")

      //- this panel we want to keep hard-wired to English as it's there to prompt them to update their AI translated languages
      uc-lightbox#lightbox-rerun-translations
        div(dir="ltr")
          p Do you want to generate new machine translations for the edits you made in English?
          p Any translations which have been edited will not be changed.

          .grid.grid-cols-3.gap-2.my-4
            div(v-for="lang in languages").flex.gap-2.bg-gray-200.p-2.items-center.justify-start
              span  
                Icon(icon="mdi:check-circle" v-if="statuses[`lightbox-translate-${lang}`]?.success") 
                Icon(icon="svg-spinners:180-ring-with-bg" v-else-if="statuses[`lightbox-translate-${lang}`]?.pending") 
                Icon(icon="mdi:close-circle" v-else-if="statuses[`lightbox-translate-${lang}`]?.error")
                Icon.opacity-0(icon="mdi:circle" v-else="")

              span {{languageData?.[lang]?.english}} ({{ lang }})

            p
              span(v-if="statuses['lightbox-rerun-translations']?.pending") Generating translations...
              span(v-else-if="statuses['lightbox-rerun-translations']?.success") Translations generated successfully.
              span(v-else-if="statuses['lightbox-rerun-translations']?.error") Translations completed with errors.
              span(v-else="") &nbsp;

        template(v-slot:buttons="{ close }")
          .primary-indigo.flex.gap-4
              button.btn.btn-secondary(@click="closeLightbox" :disabled="statuses['lightbox-rerun-translations']?.pending") Close
              button.btn.btn-primary(@click="rerunTranslations" :disabled="statuses['lightbox-rerun-translations']?.pending" v-if="!statuses['lightbox-rerun-translations']?.success") Generate

      uc-lightbox#lightbox-editor-demo.primary-sky.sm_p-4(v-if="isReview"   close-button="true")        
        .text-center.flex.flex-col.gap-2.max-w-prose
          h2.m-0.mb-2.text-xl.text-indigo-700.font-semibold.inline-flex.items-center.gap-2.justify-center
            uc-icon.text-3xl.-ms-2(icon="mdi:auto-fix")
            span Welcome to our in-browser editor 
          p.m-0 Please note that <strong>this is a demo and your edits will not be saved.</strong> 
          p.m-0 To save your changes and experience the full functionality, click “Get in touch” and we will contact you at <b class="font-semibold">{{ SCORM.userName }}</b>.
          video.mt-6.aspect-video.mx-auto.bg-zinc-900(src="https://player.vimeo.com/progressive_redirect/playback/996177552/rendition/540p/file.mp4%20%28540p%29.mp4?loc=external&signature=3a456060113b10c47ae7a5a7279b70d399eb581ece62c18aeeece9515bbb1be0" controls="true" autoplay="true" muted="true" class="max-h-[50vh]" width="1600" height="900")

        template(v-slot:buttons="{close}")
          .primary-indigo.text-center.w-full.flex.justify-center.gap-4
            span
              uc-button.btn.btn-primary(text="Get in touch" @click="getInTouch" :disabled="submitStatus==='pending' || submitStatus==='success'" ) 
          .auto-alpha-0.mt-4.-mb-6.text-center(:class="{'auto-alpha-1': submitStatus !== 'idle'}") 
            span.italic.text-gray-700(v-if="submitStatus === 'error'") Oops, something went wrong! Please try again or write to <b><a href="mailto:enquiries@vinciworks.com?subject=I would like to try the Portal">enquiries@vinciworks.com</a></b>.
            span.font-semibold.text-indigo-500.inline-flex.items-center.gap-2(v-else-if="submitStatus === 'pending'")
              span One moment...
            span.font-semibold.text-indigo-500.inline-flex.items-center.gap-2(v-else="") 
              uc-icon(icon="theme:check-circle")
              span Thank you for your interest! We will be in touch by email.
            
      uc-lightbox#lightbox-editor-demo-sales.primary-sky.sm_p-4(v-if="isSalesDemo" close-button="true")        
        .text-center.flex.flex-col.gap-2.max-w-prose
          h2.m-0.mb-2.text-xl.text-indigo-700.font-semibold.inline-flex.items-center.gap-2.justify-center
            uc-icon.text-3xl.-ms-2(icon="mdi:auto-fix")
            span Welcome to our in-browser editor 
          p.m-0 Please note that <strong>this is a demo and your edits will not be saved.</strong>

        template(v-slot:buttons="")
          span

      uc-lightbox#lightbox-unlock-adaptive.sm_p-4.primary-indigo(:locked="true")
        .max-w-prose.prose-stack.prose
          h3
            uc-text(
              text="Unlocking adaptive learning"
            )
          uc-text(
            text="This course is **adaptive**, meaning it contains content which only appears when users fail to answer the associated questions correctly."
            type="p"
          )
          uc-text(
            text="To help you tailor this course to your needs, we will **automatically unlock all related content** by marking all those questions as 'failed'. You won't need to answer more questions incorrectly to see related course content."
            type="p"
          )
          
        template(v-slot:buttons="{ close }")
          .primary-indigo
            button.btn.btn-primary(@click="unlockAdaptiveContent") OK

      //- uc-lightbox#lightbox_edit_share
        .primary-indigo
          .grid.lg_grid-cols-2.gap-12
            .col.prose-stack
              p.subheading 1. Share
              p Send this link to your colleagues so they can see your latest changes.
              p.share-input.relative
              .inline-flex.w-full.gap-1
                input#share-input.share-input__input.flex-1.px-4.text-gray-400.ring.ring-gray-300.ring-2.rounded.text-ellipsis(
                  :readonly="true"
                  :value="shareURL"
                  onfocus="this.select()"
                )
                uc-button#share-input-button.btn.btn-primary.ripple.px-6(
                  @click="copyShareURL"
                  icon="mdi:content-copy"
                  text="Copy"
                  type="button"
                )

            .col.prose-stack
              p.subheading 2. Submit to VinciWorks
              p It typically takes us 1-2 days to publish your custom course and we will confirm when it is ready to use.

              p If you do not license our course editing package, we'll be in touch with a quote.

              p  #[strong Note:] The branding and editing features do not appear in the finished product. Your users will not see them.

              p If you have any questions or further requests you can email us at #[a(href="mailto:customisations@vinciworks.com") customisations@vinciworks.com].

              p.flex.gap-8.items-center
                uc-button#submit-input-button.btn.btn-primary.ripple.float-right(
                  :disabled="submitStatus === 'pending'"
                  @click="submit"
                  icon="mdi:send"
                  text="Submit"
                )

                .collapsed-items
                  mixin status(submitStatus, message)
                    .collapsed-item
                      span.italic.text-gray-700.auto-alpha-0(
                        :class=`{ 'auto-alpha-1': submitStatus === '${submitStatus}' }`
                      )
                        uc-text(text=`${message}`)

                  +status('pending', 'Submitting...')
                  +status('success', 'Submitted!')
                  +status('error', 'Something went wrong.')

        template(v-slot:buttons="")
          span
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { computed, ref, onMounted, watch } from 'vue';
import openLightbox, { closeLightbox } from '../lib/openLightbox';
import useContent from '../stores/useContent';
import useEditMode, { type Mode } from '../stores/useEditMode';
import useSuspend from '../lib/useSuspend';
// import ScreenCarousel from './screen-carousel.vue';
import SCORM, {
  getCourseId,
  getFirm,
  setExit,
  getLocation
} from '../lib/SCORM';
// import yaml from 'js-yaml';
import { mute, unmute } from '../lib/audio';
import languageData from '../lib/languages.json';
import useRequestStatus from '../lib/useRequestStatus';
import { Icon } from '@iconify/vue';
import { commitClientEdits, createAiTranslations } from '../lib/callModContent';
import { createAIAudio } from '../author/lib/callModContentAuthors';
import loadTranslations from '../lib/loadTranslations';
import useTranslations from '../stores/useTranslations';
import createAudioScript from '../lib/createAudioScript.js';
import { runAudioProgressAnimation } from '../lib/audioProgressAnimation';
// import type { Content } from '../lib/types';
import getJWT from '../lib/getJWT';
import useQuizzes from '../stores/useQuizzes';

const { statuses, set: setStatus } = useRequestStatus();

const editMode = useEditMode();
const { setMode } = editMode;
const { available } = storeToRefs(editMode);
const mode = computed(() => editMode.mode);
const isAuthoring = __AUTHORING__;
const suspend = useSuspend();
const translations = useTranslations();
const canCloseCourse = window.opener !== null;
const courseId = getCourseId();
const firmCode = getFirm();
const quizzes = useQuizzes();

let savedMuteState;

const isReview = SCORM.isFirm('REVIEW');
const isSalesDemo = SCORM.isFirm('VINCI_ADMIN');

const { saveStatus } = storeToRefs(useContent());

const languages = computed(() => {
  const content = useContent().compiled;
  return content.languages?.filter(l => l !== 'en-GB') || [];
});

const audioPathLanguages = computed(() => {
  const content = useContent().compiled;
  return content.course?.audio ? Object.keys(content.course.audio) : [];
});

const baseCourseId = computed(() => {
  const content = useContent().compiled;
  return content['base-course'] ?? undefined;
});

// expose these strings for framework translations
// text="Saving..."
// text="Changes saved."
// text="Unsaved changes."
// text="Failed to save."
const savedMessage = computed(() => {
  if (saveStatus.value === 'saving') return 'Saving...';
  if (saveStatus.value === 'saved') return 'Changes saved.';
  if (saveStatus.value === 'unsaved') return 'Unsaved changes.';
  if (saveStatus.value === 'error') return 'Failed to save.';
  return '';
});

onMounted(() => {
  // // fallback in case there isnt a course-title with a TL
  gsap.to('.uc-edit-bar', {
    opacity: 1,
    yPercent: 0,
    duration: 1,
    delay: 7,
    overwrite: true
  });
});

const submitStatus = ref('');

const saveErrorEmailUrl = ref('');
const resyncErrorEmailUrl = `mailto:support@vinciworks.com?subject=My resync audio failed for (${firmCode}_${courseId})`;

/*const saveChanges = async () => {
  openLightbox('lightbox-save-error');
  // useContent().commit();
};*/

const unlockAdaptiveContent = () => {
  closeLightbox();
  if (quizzes.isAdaptiveCourse && !quizzes.unlockedForEditMode)
    quizzes.setAllQuizzesForEditMode(mode.value === 'edit');
};

const closeCourse = () => {
  console.log('Exit course after failed edit-mode save');
  stop();
  setExit();

  // close this window
  if (canCloseCourse) {
    window.close();
  } else {
    // if the connection is dead we can't navigate to a new page, so we just replace the html with new "close" content
    document.querySelector('html').innerHTML = `
<!DOCTYPE html>
<html lang="en" dir="ltr">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Please close</title>
    <style>
      html {
        background-color:#464753;
        color: white;
        font-family: 'Trebuchet MS', 'Lucida Sans', 'Arial', 'sans-serif';
        font-size: 1.2em;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
      }
    </style>
  </head>
  <body>
    <p>Please close this tab/window or exit via your LMS.</p>
  </body>
</html>
    `;
  }
};

// this is used when the mailer fails to send the error report email and we fallback to a mailto link
const sendErrorReportEmail = e => {
  e.preventDefault();
  if (e.target.href || e.target.parentElement.href) {
    window.location.href = e.target.href ?? e.target.parentElement.href;
    closeCourse();
  }
};

const getInTouch = async () => {
  submitStatus.value = 'pending';

  const response = await fetch(
    'https://lms.vinciworks.com/coreapps/vincimail/vincimailer.php',
    {
      method: 'POST',
      body: JSON.stringify({
        recipients: [
          {
            address: 'enquiries@vinciworks.com',
            firstName: 'Enquiries',
            lastName: ''
          },
          {
            address: 'rafi.miller@vinciworks.com',
            firstName: 'Rafi',
            lastName: 'Miller'
          }
        ],
        sender: {
          address: SCORM.userName,
          firstName: SCORM.firstName,
          lastName: SCORM.lastName
        },
        replyTo: 'no-reply@vinciworks.com',
        subject: `${SCORM.firstName} ${SCORM.lastName} wants to access the VinciWorks Portal`,
        messageBody: {
          type: 'plaintext',
          body: `

Course: ${useContent().compiled.course.title.trim()}
Course ID: ${courseId}

${SCORM.firstName} ${SCORM.lastName} (${
            SCORM.userName
          }) clicked "Get in touch" in the edit mode pop-up and wants to access the VinciWorks Portal.

Thank you!
           `
        }
      })
    }
  ).catch(e => {
    console.error(e);
    submitStatus.value = 'error';
  });

  if (response && response.ok) {
    submitStatus.value = 'success';
  } else {
    submitStatus.value = 'error';
  }
};

const reportSaveError = async () => {
  submitStatus.value = 'pending';

  const locale = suspend.locale;
  const location = getLocation();
  const userProfile = getJWT().userProfile;
  const edits = useContent().edits;
  const patches = useContent().content.patches;
  const emailSubject = `Course edit failed to save (${firmCode}_${courseId})`;
  const emailBody = `Hi Customisations Team,

I would like to report an issue experienced when editing a course in the VinciWorks Portal:

Course: ${useContent().compiled.course.title.trim()}
ID: ${courseId}
Firm: ${firmCode}
Locale: ${locale}
Location: ${location}
Browser: ${navigator.userAgent}

Recent changes: ${JSON.stringify(edits)}

Thank you!

${userProfile.firstName} ${userProfile.lastName}
${userProfile.email}
`;

  try {
    // test the fetch response first with just header
    const testResponse = await fetch(
      'https://lms.vinciworks.com/coreapps/vincimail/vincimailer.php',
      {
        method: 'HEAD'
      }
    );

    if (!testResponse.ok) {
      throw new Error('Failed to reach email service');
    }

    const response = await fetch(
      'https://lms.vinciworks.com/coreapps/vincimail/vincimailer.php',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify({
          recipients: [
            {
              address: 'customisations@vinciworks.com',
              firstName: 'Customisations',
              lastName: 'Team'
            },
            {
              address: 'nathan.mckinley@vinciworks.com',
              firstName: 'Nathan',
              lastName: 'McKinley'
            }
          ],
          sender: {
            address: userProfile.email,
            firstName: userProfile.firstName,
            lastName: userProfile.lastName
          },
          replyTo: 'no-reply@vinciworks.com',
          subject: emailSubject,
          messageBody: {
            type: 'plaintext',
            body: emailBody
          }
        })
      }
    );

    if (response.ok) {
      submitStatus.value = 'success';
    } else {
      throw new Error('Failed to send email');
    }
  } catch (e) {
    console.error(e.message);

    // this is used when the mailer fails to send the error report email
    const email = {
      to: 'support@vinciworks.com',
      subject: emailSubject,
      body: emailBody
    };

    saveErrorEmailUrl.value = `mailto:${email.to}?subject=${
      email.subject
    }&body=${encodeURIComponent(email.body)}`;

    submitStatus.value = 'error';
  }
};

function changeMode(mode: Mode) {
  if (mode === editMode.mode) return;

  // mute and restore the previous setting when switching to/from edit mode
  if (mode === 'edit') {
    savedMuteState = suspend.narrationMute;
    mute();
  } else {
    savedMuteState ? mute() : unmute();
  }

  setMode(mode);
}

const onClickEditor = async () => {
  changeMode('edit');

  if (isReview) {
    submitStatus.value = 'idle';
    await new Promise(resolve => setTimeout(resolve, 500));
    openLightbox('lightbox-editor-demo');
  } else if (isSalesDemo) {
    submitStatus.value = 'idle';
    await new Promise(resolve => setTimeout(resolve, 500));
    openLightbox('lightbox-editor-demo-sales');
  } else if (quizzes.isAdaptiveCourse && !quizzes.unlockedForEditMode) {
    await new Promise(resolve => setTimeout(resolve, 500));
    openLightbox('lightbox-unlock-adaptive');
  }
};

const setTranslationsInvalidated = useContent().setTranslationsInvalidated;

const translationsAllSuccessful = computed(() => {
  return languages.value.every(
    lang => statuses[`lightbox-translate-${lang}`]?.success
  );
});

const rerunTranslations = async () => {
  const langs = languages.value;
  setStatus('lightbox-rerun-translations', {
    pending: true,
    idle: false,
    success: false
  });
  await commitClientEdits();

  for (const lang of langs) {
    setStatus(`lightbox-translate-${lang}`, { pending: true });

    try {
      await createAiTranslations({
        courseId: courseId,
        firmCode: firmCode,
        to: lang
      });

      setStatus(`lightbox-translate-${lang}`, { success: true });

      // test error handling
      // if (lang === 'es') throw new Error('test error');
    } catch (e) {
      setStatus(`lightbox-translate-${lang}`, { error: e.message });
    }
  }

  const newTranslations = await loadTranslations(langs, baseCourseId.value);
  translations.load(newTranslations);

  setStatus('lightbox-rerun-translations', {
    idle: true,
    pending: false,
    success: translationsAllSuccessful.value,
    error: translationsAllSuccessful.value ? '' : 'Some translations failed.'
  });
  setTranslationsInvalidated(false);

  // emit a custom event so we can refresh editor contents in the tip-tap editor
  document.getElementById('app')?.dispatchEvent(
    new CustomEvent('translationsUpdated', {
      detail: { translations: newTranslations }
    })
  );
};

const animationSpeed = ref('btn--animateFast');
const displayAudioBtn = ref('hidden');
const isResyncCompleted = ref(false);
const loadCourseError = ref('');
const audioScript = ref('');

// watch for a save status change
watch(saveStatus, status => {
  if (
    status !== 'clean' &&
    status !== 'error' &&
    audioPathLanguages.value.length > 0
  ) {
    displayAudioBtn.value = 'inline-flex';
  } else {
    displayAudioBtn.value = 'hidden';

    if (!isReview && !isSalesDemo && status === 'error') {
      const onKeydown = async e => {
        e.preventDefault();
      };

      document.addEventListener('keydown', onKeydown);

      openLightbox('lightbox-save-error');
    }
  }
});

const openResyncLightbox = async () => {
  animationSpeed.value = 'btn--animateSlow';

  await commitClientEdits();

  if (
    useContent().translationsInvalidated &&
    audioPathLanguages.value.length > 1
  ) {
    openLightbox('lightbox-audio-translations-check');
  } else {
    openLightbox('lightbox-confirm-resync-audio');
  }
};

const closeLightboxAndReload = () => {
  closeLightbox();
  window.location.reload();
};

const retryResyncAudio = () => {
  closeLightbox();
  isResyncCompleted.value = false;
  isResyncError.value = false;
  openLightbox('lightbox-confirm-resync-audio');
};

const handleTranslationsUpdate = async () => {
  await rerunTranslations();
};

const proceedToAudioResync = () => {
  closeLightbox();
  openLightbox('lightbox-confirm-resync-audio');
};

const courseAudioIFrame = ref<HTMLIFrameElement>();
const progressMessage = ref('');
const currentLanguage = ref('');
const isResyncError = ref(false);

const updateProgressMessage = async (message: string, delay: number) => {
  progressMessage.value = message;
  await new Promise(resolve => setTimeout(resolve, delay * 1000));
};

const pollStatus = (summaryFilePath: string, interval = 5000) => {
  return new Promise((resolve, reject) => {
    // These commented out lines are for testing error handling
    // let attempts = 0;
    const checkStatus = async () => {
      // attempts++;
      // if (attempts > 1) {
      //   reject(new Error("Forced error for testing purposes."));
      //   return;
      // }
      try {
        const summaryData = await fetch(summaryFilePath, {
          cache: 'no-cache'
        }).then(res => res.json());
        console.log('Checking status:', summaryData.status);

        if (summaryData.status === 'success') {
          const pathOnly = summaryFilePath.substring(
            0,
            summaryFilePath.lastIndexOf('/') + 1
          );
          resolve(pathOnly);
        } else if (summaryData.status === 'error' || summaryData.error) {
          reject(new Error(summaryData.message || 'Failed to create audio'));
        } else {
          setTimeout(checkStatus, interval);
        }
      } catch (error) {
        reject(new Error('Failed to check audio status'));
      }
    };
    checkStatus();
  });
};

// expose these strings for framework translations
// text="This may take a few minutes."
// text="Fetching your edited content."
// text="Sending everything to the narrator."
// text="Recording your new version."
// text="Making some final tweaks."
// text="Your course audio has been resynced!"
// text="Don't worry - your edits are safe. {n} Please close this message or try resyncing again. {n} If the issue persists, contact">
const progressMessageText = {
  fewmins: 'This may take a few minutes.',
  fetching: 'Fetching your edited content.',
  sending: 'Sending everything to the narrator.',
  recording: 'Recording your new version.',
  tweaking: 'Making some final tweaks.',
  resynced: 'Your course audio has been resynced!',
  error:
    "Don't worry - your edits are safe. {n} Please close this message or try resyncing again. {n} If the issue persists, contact"
};

const runResyncAudio = async () => {
  closeLightbox();
  openLightbox('lightbox-resync-audio-progress');

  // Start progress animation
  setTimeout(() => {
    const el = document.getElementById('audio-sync-progress-indicator-wrapper');
    if (el instanceof HTMLCanvasElement) {
      runAudioProgressAnimation(
        el,
        () => isResyncCompleted.value || isResyncError.value
      );
    }
  }, 250);

  try {
    await updateProgressMessage(progressMessageText.fewmins, 3);

    for (const language of audioPathLanguages.value) {
      currentLanguage.value = language;

      // Wait for iframe to be available after lightbox opens
      await new Promise(resolve => setTimeout(resolve, 500));

      const iframe = courseAudioIFrame.value;
      if (!iframe) {
        throw new Error('Audio iframe not found - please try again');
      }

      await updateProgressMessage(progressMessageText.fetching, 3);

      // Set up load promise before changing src
      const loadPromise = new Promise((resolve, reject) => {
        const handleLoad = () => {
          console.log('Iframe loaded successfully');
          iframe.removeEventListener('load', handleLoad);
          resolve(true);
        };

        const handleError = (error: ErrorEvent) => {
          console.error('Iframe load error:', error);
          iframe.removeEventListener('error', handleError);
          reject(new Error('Failed to load iframe content'));
        };

        iframe.addEventListener('load', handleLoad);
        iframe.addEventListener('error', handleError);
      });

      // Set iframe source
      iframe.src = url.value;
      console.log('Loading iframe with URL:', iframe.src);

      // Wait for load
      await loadPromise;

      // Wait for pages element to be available
      const pages = await new Promise<Element>((resolve, reject) => {
        const checkForPages = () => {
          const cw = iframe.contentWindow as Window;
          const pages = cw.document.documentElement.querySelector('.pages');
          if (pages) {
            resolve(pages);
          } else {
            setTimeout(checkForPages, 500);
          }
        };
        checkForPages();
      });

      await updateProgressMessage(progressMessageText.sending, 3);

      // Generate audio script
      audioScript.value = await createAudioScript(pages);

      // console.log('Audio script:', JSON.parse(audioScript.value));

      // Create audio
      const data = {
        courseId: getCourseId(),
        firmCode: getFirm(),
        lang: language,
        audioScript: audioScript.value,
        voiceData: '',
        uploadAudio: true
      };

      await updateProgressMessage(progressMessageText.recording, 0);

      try {
        const response = await createAIAudio(data);
        console.log('Audio creation response:', response);

        if (!response?.summary) {
          throw new Error('No summary path returned from audio creation');
        }
        // Poll for completion
        await pollStatus(response.summary);
        await updateProgressMessage(progressMessageText.tweaking, 3);
      } catch (error) {
        console.error('Error creating audio:', error);
        throw new Error(
          `Failed to create audio for ${language}: ${error.message}`
        );
      }
    }

    // Show completion after all languages are processed
    progressMessage.value = progressMessageText.resynced;
    currentLanguage.value = '';
    isResyncCompleted.value = true;
    saveStatus.value = 'clean';
  } catch (error) {
    console.error('Error processing languages:', error);
    isResyncError.value = true;
    progressMessage.value = progressMessageText.error;
    loadCourseError.value = error.message;
  }
};

const url = computed(() => {
  const courseId = getCourseId();
  const firmCode = getFirm();
  const localServer = window.location.origin.includes('local');
  const portalOrigin = new URL(window.location.href).origin;
  const courseQ = `courseid=${courseId}`;
  const firmQ = firmCode ? `firm=${firmCode}` : '';
  const langQ = `lang=${currentLanguage.value || 'en-GB'}`;
  const tagQ = 'tags=worddoc+includeall&audioDoc=1&ucClientEditModeAudio=1';
  const queryString = ['turbo=999999', courseQ, firmQ, langQ, tagQ]
    .filter(Boolean)
    .join('&');

  return localServer
    ? `./app.html?${queryString}`
    : `${portalOrigin}/awscontent/ubercourse/latest/app.html?${queryString}`;
});

const isMultiLingualResync = computed(
  () => audioPathLanguages.value.length > 1
);

const isConfirmingCancel = ref(false);

const handleCancelClick = () => {
  isConfirmingCancel.value = true;
};

const handleContinueResync = () => {
  isConfirmingCancel.value = false;
};
</script>

<style>
#lightbox-editor-demo .self-end {
  align-self: center;
}

#lightbox-editor-demo-sales .self-end {
  align-self: center;
}

#lightbox-save-error .self-end {
  align-self: center;
}

#lightbox-confirm-resync-audio .self-end,
#lightbox-audio-translations-success .self-end,
#lightbox-audio-translations-check .self-end,
#lightbox-resync-audio-progress .self-end {
  display: none;
}

.progress-indicator h3 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
}

.btn--animateSlow {
  animation: colorChangeShockwaveSlow 6s ease-out infinite;
}

.btn--animateFast {
  animation: colorChangeShockwave 2s ease-out infinite;
}

@keyframes colorChangeWiggle {
  0% {
    background: rgb(var(--color-indigo-800));
    transform: rotate(-3deg);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  }
  5% {
    transform: rotate(5deg);
  }
  11% {
    transform: rotate(-3deg);
  }
  14% {
    transform: rotate(1deg);
  }
  18% {
    transform: rotate(-0.5deg);
  }
  22% {
    transform: rotate(0);
  }
  49% {
    transform: rotate(0);
  }
  50% {
    background: rgb(var(--color-violet-500));
    transform: rotate(-3deg);
  }
  55% {
    transform: rotate(5deg);
  }
  61% {
    transform: rotate(-3deg);
  }
  64% {
    transform: rotate(1deg);
  }
  68% {
    transform: rotate(-0.5deg);
  }
  72% {
    transform: rotate(0);
  }
  100% {
    background: rgb(var(--color-indigo-800));
    transform: rotate(0);
  }
}

@keyframes colorChangeWiggleSlow {
  0% {
    background: rgb(var(--color-indigo-800));
    transform: rotate(-3deg);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
  }
  1.67% {
    transform: rotate(5deg);
  }
  3.67% {
    transform: rotate(-3deg);
  }
  4.67% {
    transform: rotate(1deg);
  }
  6% {
    transform: rotate(-0.5deg);
  }
  7.33% {
    transform: rotate(0);
  }
  49% {
    transform: rotate(0);
  }
  50% {
    background: rgb(var(--color-violet-500));
  }
  100% {
    background: rgb(var(--color-indigo-800));
    transform: rotate(0);
  }
}

@keyframes colorChangeShockwave {
  0% {
    background: rgb(var(--color-indigo-800));
    transform: scale(1);
  }
  5% {
    transform: scale(1.08);
  }
  11% {
    transform: scale(0.98);
  }
  14% {
    transform: scale(1.02);
  }
  18% {
    transform: scale(0.98);
  }
  22% {
    transform: scale(1);
  }
  49% {
    transform: scale(1);
  }
  50% {
    background: rgb(var(--color-violet-500));
    transform: scale(1);
  }
  55% {
    transform: scale(1.08);
  }
  61% {
    transform: scale(0.98);
  }
  64% {
    transform: scale(1.02);
  }
  68% {
    transform: scale(0.98);
  }
  72% {
    transform: scale(1);
  }
  100% {
    background: rgb(var(--color-indigo-800));
    transform: scale(1);
  }
}

@keyframes colorChangeShockwaveSlow {
  0% {
    background: rgb(var(--color-indigo-800));
    transform: scale(1);
  }
  1.67% {
    transform: scale(1.08);
  }
  3.67% {
    transform: scale(0.98);
  }
  4.67% {
    transform: scale(1.02);
  }
  6% {
    transform: scale(0.98);
  }
  7.33% {
    transform: scale(1);
  }
  49% {
    transform: scale(1);
  }
  50% {
    background: rgb(var(--color-violet-500));
  }
  100% {
    background: rgb(var(--color-indigo-800));
    transform: scale(1);
  }
}
</style>
